/**
 * Copyright 2022-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Box, Tab, Tabs as TabContainer } from "@nordcloud/gnui";
import { useTabStepNavigation } from "~/hooks";
import { ActionPlansTab } from "./ActionPlansTab/ActionPlansTab";
import { ActionSettingsTab } from "./ActionSettingsTab/ActionSettingsTab";

const TAB_STEP_MAPPING: Record<string, number> = {
  settings: 0,
  plans: 1,
};

export function Tabs() {
  const { currentStep, handleTab } = useTabStepNavigation(TAB_STEP_MAPPING);

  return (
    <Box spacing="spacing02" css={{ padding: 0 }}>
      <TabContainer step={currentStep} handleTab={handleTab}>
        <Tab heading="Action Settings">
          <ActionSettingsTab />
        </Tab>
        <Tab heading="Action Plans">
          <ActionPlansTab />
        </Tab>
      </TabContainer>
    </Box>
  );
}
